export default function WhenNeeded() {
  const signs = [
    { icon: 'ri-arrow-down-line', title: 'Продажи не растут', desc: 'Несмотря на маркетинговые усилия, показатели отдела продаж не меняются месяцами' },
    { icon: 'ri-discount-percent-line', title: 'Скидки стали нормой', desc: 'Менеджеры раздают скидки при первой же возможности, снижая маржинальность бизнеса' },
    { icon: 'ri-computer-line', title: 'CRM заполнена, но не работает', desc: 'Данные есть, но аналитика не даёт управленческих решений' },
    { icon: 'ri-emotion-sad-line', title: 'Менеджеры боятся цены', desc: 'Сотрудники не могут аргументировать стоимость и уступают клиенту' },
    { icon: 'ri-user-star-line', title: 'Руководитель продаёт лучше команды', desc: 'РОП замыкает все сложные сделки на себя, команда не развивается' },
    { icon: 'ri-advertisement-line', title: 'Реклама работает, заявок нет', desc: 'Лидогенерация налажена, но конверсия в продажи минимальна' },
    { icon: 'ri-timer-line', title: 'Новые сотрудники долго выходят на результат', desc: 'Отсутствует система онбординга, newcomers теряются в процессах' },
    { icon: 'ri-file-copy-line', title: 'Нет единых стандартов продаж', desc: 'Каждый менеджер продаёт по-своему, невозможно масштабировать успешный опыт' },
  ];

  return (
    <section id="when-needed" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Когда компании нужен <strong>тренинг по продажам</strong>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Проведите быструю самодиагностику. Если вы узнали хотя бы два пункта — пора действовать.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {signs.map((sign, i) => (
            <div key={i} className="bg-gray-50 rounded-xl p-6 hover:bg-teal-50 hover:shadow-md transition-all duration-300 group cursor-default">
              <div className="w-11 h-11 bg-white rounded-lg flex items-center justify-center mb-4 shadow-sm group-hover:bg-teal-600 transition-colors duration-300 flex-shrink-0">
                <i className={`${sign.icon} text-lg text-teal-600 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="text-base font-bold text-gray-900 mb-2">{sign.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{sign.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}